import type { TokenSymbol, } from "./TokenSymbol";
import type { ValidChainId, } from "./ValidChainId";
import type { TokenAddress, } from "./Token";


/** A trait that uniquely identifies a token on a specific chain */
export declare type TokenTraits<C extends ValidChainId = 1> = {
  chainId: ValidChainId;
  symbol?: string; //TokenSymbol<C>;
  address?: string; //TokenAddress<C>;
  identifier?: string; //TokenIdentifier<C>;
}

/** Check if a value is a TokenTrait with symbol and chainId properties
 * @todo - improve this by evaluating if the symbol is valid and exists */
export const hasTokenTraits = <C extends ValidChainId = 1>( value: unknown ): value is TokenTraits<C> => {
  if(typeof value === "object" && !Array.isArray(value) && value !== null) {
    if("chainId" in value) {
      if("symbol" in value || "address" in value || "identifier" in value) {
        return true;
      }
    }
  }
  return false;
}
